import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const EntradasTiempo = React.lazy(
  () => import("../screean/entradasTiempo/entradas")
);
export function entradasFiltradas() {
  return (
    <Route
      path="/entradas-tiempo"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <EntradasTiempo />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
